import React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const Parents = ({ fill = 'gcBlue', size = 'xsmall', height, width, className }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            width={width ?? IconSizes[size]}
            height={height ?? IconSizes[size]}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M12 14C12.5523 14 13 14.4477 13 15C12.9998 15.5521 12.5522 16 12 16H4C2.89543 16 2 16.8954 2 18V21C1.99984 21.5521 1.55218 22 1 22C0.447817 22 0.000164893 21.5521 0 21V18C0 15.7909 1.79086 14 4 14H12ZM20 16C22.2091 16 24 17.7909 24 20V21C23.9998 21.5521 23.5522 22 23 22C22.4478 22 22.0002 21.5521 22 21V20C22 18.8954 21.1046 18 20 18H16C14.8954 18 14 18.8954 14 20V21C13.9998 21.5521 13.5522 22 13 22C12.4478 22 12.0002 21.5521 12 21V20C12 17.7909 13.7909 16 16 16H20ZM18 7C20.2091 7 22 8.79086 22 11C21.9998 13.209 20.209 15 18 15C15.791 15 14.0002 13.209 14 11C14 8.79086 15.7909 7 18 7ZM18 9C16.8954 9 16 9.89543 16 11C16.0002 12.1044 16.8955 13 18 13C19.1045 13 19.9998 12.1044 20 11C20 9.89543 19.1046 9 18 9ZM7.75 3C10.3734 3 12.5 5.12665 12.5 7.75C12.4998 10.3732 10.3733 12.5 7.75 12.5C5.12675 12.5 3.00016 10.3732 3 7.75C3 5.12665 5.12665 3 7.75 3ZM7.75 5C6.23122 5 5 6.23122 5 7.75C5.00016 9.26864 6.23132 10.5 7.75 10.5C9.26868 10.5 10.4998 9.26864 10.5 7.75C10.5 6.23122 9.26878 5 7.75 5Z"
                className={fillStyles}
            />
        </svg>
    );
};
